export default function MobileTabBar({ items, activeId, onSelect, label = "التنقل الرئيسي" }) {
  return (
    <nav
      aria-label={label}
      className="fixed inset-x-0 bottom-0 z-40 border-t border-border/80 bg-card/95 px-2 pt-2 shadow-[0_-8px_24px_hsl(var(--brand)/0.06)] backdrop-blur-xl md:hidden"
      style={{ paddingBottom: "max(env(safe-area-inset-bottom), 0.5rem)" }}
    >
      <div className="mx-auto grid max-w-lg gap-1" style={{ gridTemplateColumns: `repeat(${items.length}, minmax(0, 1fr))` }}>
        {items.map((item) => {
          const active = activeId === item.id;
          const Icon = item.icon;
          return (
            <button
              key={item.id}
              type="button"
              data-testid={`mobile-tab-${item.id}`}
              aria-current={active ? "page" : undefined}
              aria-label={item.badge > 0 ? `${item.label}، ${item.badge} عناصر` : item.label}
              onClick={() => onSelect(item.id)}
              className={`relative flex min-h-14 flex-col items-center justify-center gap-1 rounded-2xl px-1 text-[10px] font-bold transition-colors active:scale-[0.97] ${
                active ? "bg-primary/[0.08] text-primary" : "text-muted-foreground hover:bg-muted/70"
              }`}
            >
              <span className="relative">
                <Icon className="h-5 w-5" strokeWidth={active ? 2.5 : 2} />
                {item.badge > 0 && (
                  <span className="absolute -right-2 -top-2 grid h-[17px] min-w-[17px] place-items-center rounded-full bg-primary px-1 text-[9px] font-extrabold leading-none text-primary-foreground ring-2 ring-card">
                    {item.badge > 99 ? "99+" : item.badge}
                  </span>
                )}
              </span>
              <span className="max-w-full truncate">{item.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
